/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



(function () {

	var action = document.querySelector("#footer-newsletter").action;
  	action = action.replace("#footer-newsletter", "");
	document.querySelector("#footer-newsletter").action = action;
  
  	
  
    if (document.querySelector(".rte")) {
      var classes = document.querySelector(".rte").className;
      classes = classes.replace("rte", "Rte");
      document.querySelector(".rte").className = classes;
    }
  
  
  
  
    if (document.querySelector(".shopify-policy__title")) {
      var outerHtml = document.querySelector(".shopify-policy__title").outerHTML;
      outerHtml = "<header class='PageHeader'>" + outerHtml + "</header>";
      document.querySelector(".shopify-policy__title").outerHTML = outerHtml;
      document.querySelector(".shopify-policy__title").querySelector("h1").className += "SectionHeader__Heading Heading u-h1";
    }
  
  
  
  	
  	if (document.querySelector(".shopify-email-marketing-confirmation__container")) {
      var container = document.querySelector(".shopify-email-marketing-confirmation__container");
      
      container.insertAdjacentHTML("beforeBegin", 	"<div class='Container'>" + 
                                   						"<header class='PageHeader'>	<div class='SectionHeader SectionHeader--center'>	<h1 class='SectionHeader__Heading Heading u-h1'>Newsletter</h1>	</div>	</header>" +
                                   						"<div class='PageContent PageContent--narrow Rte'>" +
                                   							
                                   						"</div>" + 
                                   					"</div>");
      
      container.querySelector("h1").remove();
      
      document.querySelector(".PageContent").appendChild(container);
      
      if (container.querySelector("a")) {
      
        container.querySelector("p").innerText = "Vielen Dank für deine Anmeldung unseres Newsletters!";
        container.querySelector("p").insertAdjacentHTML("afterEnd", "<p>Du erhältst in Kürze eine Willkommensnachricht mit deinem Couponcode in dein E-Mail-Postfach. Schaue am besten auch in deinem Spamordner nach.</p>");
      }
      
    }
  
  
  if (document.querySelector(".Product")) {
    
    if (document.querySelector(".ProductMeta__Title")) {
      var title = document.querySelector(".ProductMeta__Title");
      
      if ((title.innerText.toLowerCase().includes("naga")		||
          title.innerText.toLowerCase().includes("zila")		||
          title.innerText.toLowerCase().includes("key")			||
          title.innerText.toLowerCase().includes("schlüssel")	||
          title.innerText.toLowerCase().includes("tool"))		&&
         !title.innerText.toLowerCase().includes("pre-owned")) {
        var container = document.querySelector(".Product");
      	
    	//container.insertAdjacentHTML("afterEnd", 	"<header class='PageHeader'>	<div class='SectionHeader SectionHeader--center'>	<h3 class='SectionHeader__Heading Heading u-h3'>Auch im Set verfügbar</h3>	</div>	</header>");
      }
      
      
      if (title.innerText.toLowerCase().includes("gutschein")) {
          document.querySelectorAll(".Collapsible__Button").forEach(function(item){
                if (item.textContent.toLowerCase().includes("lieferzeiten")) {
					item.parentElement.remove();
                }
      		});
      }
      
    }
    	
 
    }


  if (document.querySelector(".bndlr-landing-page")) {
      var box = document.querySelector(".bndlr-landing-page");
      box.classList.add("Rte");
  }
  
  
})();
